import { render, staticRenderFns } from "./swiper-table.vue?vue&type=template&id=190180e5&"
import script from "./swiper-table.vue?vue&type=script&lang=js&"
export * from "./swiper-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports